import { ILandingPageProps } from '../../interfaces/IPages';
import { IShipItem } from '../../interfaces/ship/IShip';
import React from 'react';
import ShipDetail from '../components/sections/ship-detail/ship-detail';

export const ShipDetailsMod = ({ getLandingPage, modulesData }: ILandingPageProps['pageProps']) => {
    const shipDetailsData = modulesData[`ship${getLandingPage.id}`];
    if (!shipDetailsData || !shipDetailsData.factsAndFigures) {
        return null;
    }
    const { factsAndFigures } = shipDetailsData;
    const boardLanguage =
        factsAndFigures.spokenLanguages && factsAndFigures.spokenLanguages.length
            ? factsAndFigures.spokenLanguages[0]
            : '';
    const boardCurrency =
        factsAndFigures.currency && factsAndFigures.currency.length
            ? factsAndFigures.currency[0]
            : '';

    const shipItems: IShipItem = {
        launchDate: factsAndFigures.manufactureYear,
        refurbishmentYear: factsAndFigures.refurbishmentYear || null,
        // @TODO check the actual format that's being passed
        company: shipDetailsData.company.title,
        length: factsAndFigures.length,
        draft: factsAndFigures.draft,
        speed: factsAndFigures.speed,
        decks: factsAndFigures.decks,
        passengers: factsAndFigures.passengerCapacity,
        crew: factsAndFigures.crewMembers,
        boardLanguage,
        boardCurrency,
        backgroundImage: shipDetailsData?.headerImages?.[1],
        bannerImage: shipDetailsData?.bannerImage,
    };
    return <ShipDetail key="shipDetails" shipItems={shipItems} />;
};
